import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { APP_URL, SectionNavigation } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';

export const GetHeaderData = (isPopupWithRoute: any, selectedMessagesCount: number) => {
	const { t } = useTranslation();
	const location = useLocation();
	const { isViewActive } = useSectionNavigation();

	return [
		{
			navType: SectionNavigation.COUPON,
			navBack: SectionNavigation.HOME,
			title: t('quit'),
		},
		{
			navType: APP_URL.deposit,
			navBack: SectionNavigation.HOME,
			title: 'Wpłaty',
		},
		{
			navType: APP_URL.coupon,
			navBack: SectionNavigation.HOME,
			title: t('coupon'),
		},
		{
			navType: SectionNavigation.CP_COUPON,
			navBack: SectionNavigation.USER,
			title: t('coupon'),
		},
		{
			navType: SectionNavigation.ACCOUNT_VERIFICATION,
			navBack: SectionNavigation.HOME,
			title: t('verification'),
		},
		{
			navType: SectionNavigation.CP_DEPOSIT,
			navBack: SectionNavigation.USER,
			title: t('deposit'),
		},
		{
			navType: SectionNavigation.CP_PAYOUT,
			navBack: SectionNavigation.USER,
			title: t('payout'),
		},
		{
			navType: SectionNavigation.CP_BONUS,
			navBack: SectionNavigation.USER,
			title: t('accountSettingsBonus'),
		},
		// {
		// 	navType: SectionNavigation.CP_PROMO_CODE,
		// 	navBack: SectionNavigation.USER,
		// 	title: t('accountSettingsPromotionCode'),
		// },
		{
			navType: SectionNavigation.CP_PERSONAL_DATA,
			navBack: SectionNavigation.USER,
			title: t('generalSettingsPersonalData'),
		},
		{
			navType: SectionNavigation.CP_CHANGE_PASSWORD,
			navBack: SectionNavigation.USER,
			title: t('changePassword'),
		},
		{
			navType: SectionNavigation.CP_MARKETING_CONSENT,
			navBack: SectionNavigation.USER,
			title: t('generalSettingsConsents'),
		},
		{
			navType: SectionNavigation.CP_RESPONSIBLE_GAME,
			navBack: SectionNavigation.USER,
			title: t('generalSettingsPolicy'),
		},
		{
			navType: SectionNavigation.CP_LIMITS,
			navBack: SectionNavigation.CP_RESPONSIBLE_GAME,
			title: t('generalSettingsPolicy'),
		},
		{
			navType: SectionNavigation.CP_REGULATIONS,
			navBack: SectionNavigation.CP_RESPONSIBLE_GAME,
			title: t('rgRegulationsAndDocuments'),
		},
		{
			navType: APP_URL.login,
			navBack: SectionNavigation.HOME,
			title: t('welcomeToBetfan'),
		},
		{
			navType: APP_URL.register,
			navBack: SectionNavigation.LOGIN,
			title: t('registration'),
		},
		{
			navType: APP_URL.forgotPassword,
			navBack: SectionNavigation.LOGIN,
			title: t('changePassword'),
		},
		{
			navType: APP_URL.resetPassword,
			navBack: SectionNavigation.HOME,
			title: t('changePassword'),
		},
		{
			navType: SectionNavigation.CP_PROMO_CODE,
			navBack: SectionNavigation.USER,
			title: t('accountSettingsPromotionCode'),
		},
		{
			navType: SectionNavigation.CP_MESSAGES,
			navBack: SectionNavigation.USER,
			title: t('messageHeaderInfo', { count: selectedMessagesCount }),
		},
		{
			navType: SectionNavigation.CP_MESSAGES_DISPLAY,
			navBack: SectionNavigation.CP_MESSAGES,
			title: t('accountSettingsMessages'),
		},
		{
			navType: SectionNavigation.CP_ACTIVITY_HISTORY,
			navBack: SectionNavigation.USER,
			title: t('activityHistory'),
		},
		{
			navType: SectionNavigation.CP_SETTINGS,
			navBack: SectionNavigation.USER,
			title: t('settings'),
		},
		{
			navType: APP_URL.verificationMojeIdPrefix,
			navBack: APP_URL.home,
			title: t('welcomeToBetfan'),
		},
	].find((item) => {
		if (isPopupWithRoute) {
			if (item.navType === APP_URL.verificationMojeIdPrefix) {
				return location.pathname.startsWith(item.navType);
			}
			if (item.navType === APP_URL.resetPassword) {
				return location.pathname.includes(item.navType);
			}
			return item.navType === location.pathname;
		}
		return isViewActive(item.navType as SectionNavigation);
	});
};
